module.exports = __webpack_public_path__ + "static/img/15.a622837.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/15.png
// module id = xEL9
// module chunks = 0